export default "__VITE_ASSET__4dqX7MWF__";